
export default function Mission() {
  return (
    <section id="mission" className="py-24 px-6 lg:px-12 bg-[#F5E6D3]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="inline-block mb-4">
            <div className="w-16 h-1 bg-[#D4A574] mx-auto mb-4"></div>
            <h2 className="text-5xl md:text-6xl font-bold text-[#2C1810] font-['Space_Mono'] tracking-tight">
              OUR MISSION
            </h2>
            <div className="w-16 h-1 bg-[#D4A574] mx-auto mt-4"></div>
          </div>
          <p className="text-base text-[#5C4033] max-w-2xl mx-auto font-['DM_Sans'] mt-6 tracking-wide">
            GUIDED BY FAITH • DRIVEN BY COMPASSION • COMMITTED TO TRANSFORMATION
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div className="border-4 border-[#2C1810] p-8 bg-white">
              <div className="border-l-4 border-[#D4A574] pl-6">
                <p className="text-lg text-[#2C1810] leading-relaxed font-['Crimson_Text'] italic">
                  "And let us not grow weary of doing good, for in due season we will reap, if we do not give up."
                </p>
                <p className="text-sm text-[#D4A574] font-['Space_Mono'] mt-3 tracking-wider">
                  — GALATIANS 6:9
                </p>
              </div>
            </div>
            
            <div className="bg-[#2C1810] p-8 text-[#F5E6D3]">
              <p className="text-sm font-['DM_Sans'] leading-relaxed">
                We are dedicated to spreading the Gospel and serving our communities through acts of love and compassion. Our mission is to be the hands and feet of Christ, reaching those in need with hope, dignity, and practical support.
              </p>
            </div>
            
            <div className="bg-white border-4 border-[#D4A574] p-8">
              <p className="text-sm text-[#2C1810] font-['DM_Sans'] leading-relaxed">
                Through baptism, fellowship, and outreach programs, we create spaces where faith grows, lives are transformed, and communities flourish. Every person we serve is an opportunity to demonstrate God's unconditional love.
              </p>
            </div>
          </div>

          <div className="space-y-8">
            <div className="bg-white border-4 border-[#2C1810] p-8">
              <h3 className="text-2xl font-bold text-[#2C1810] mb-6 font-['Space_Mono'] tracking-tight">
                CORE VALUES
              </h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4 pb-6 border-b-2 border-[#F5E6D3]">
                  <div className="w-12 h-12 bg-[#D4A574] flex items-center justify-center flex-shrink-0">
                    <i className="ri-heart-fill text-2xl text-[#2C1810]"></i>
                  </div>
                  <div>
                    <strong className="text-[#2C1810] font-['Space_Mono'] text-sm tracking-wide">COMPASSION</strong>
                    <p className="text-xs text-[#5C4033] font-['DM_Sans'] mt-1">Serving with love and empathy</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 pb-6 border-b-2 border-[#F5E6D3]">
                  <div className="w-12 h-12 bg-[#D4A574] flex items-center justify-center flex-shrink-0">
                    <i className="ri-book-open-fill text-2xl text-[#2C1810]"></i>
                  </div>
                  <div>
                    <strong className="text-[#2C1810] font-['Space_Mono'] text-sm tracking-wide">FAITH</strong>
                    <p className="text-xs text-[#5C4033] font-['DM_Sans'] mt-1">Rooted in Scripture and prayer</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 pb-6 border-b-2 border-[#F5E6D3]">
                  <div className="w-12 h-12 bg-[#D4A574] flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-fill text-2xl text-[#2C1810]"></i>
                  </div>
                  <div>
                    <strong className="text-[#2C1810] font-['Space_Mono'] text-sm tracking-wide">COMMUNITY</strong>
                    <p className="text-xs text-[#5C4033] font-['DM_Sans'] mt-1">Building inclusive fellowship</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4A574] flex items-center justify-center flex-shrink-0">
                    <i className="ri-hand-heart-fill text-2xl text-[#2C1810]"></i>
                  </div>
                  <div>
                    <strong className="text-[#2C1810] font-['Space_Mono'] text-sm tracking-wide">SERVICE</strong>
                    <p className="text-xs text-[#5C4033] font-['DM_Sans'] mt-1">Meeting needs with action</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="border-4 border-[#2C1810] p-8 bg-[#D4A574]">
              <div className="border-l-4 border-[#2C1810] pl-6">
                <p className="text-base text-[#2C1810] leading-relaxed font-['Crimson_Text'] italic">
                  "Truly I tell you, whatever you did for one of the least of these brothers and sisters of mine, you did for me."
                </p>
                <p className="text-sm text-[#2C1810] font-['Space_Mono'] mt-3 tracking-wider">
                  — MATTHEW 25:40
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
